import { ToggleGroup } from "@flat-ui";
import { useThemeMode } from "@hooks/use-theme-mode";
import {
  setThemeMode,
  storeThemeMode,
  ThemeModePreference,
} from "@store/dev-features/dev-features-slice";
import { useAppDispatch } from "@store/store-helper";
import { ExperimentalFeatureEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

const THEME_MODE_ITEMS: { label: string; value: ThemeModePreference }[] = [
  { label: "Light", value: "light" },
  { label: "Dark", value: "dark" },
  { label: "System", value: "system" },
];

/** Button group to choose between the light, the dark and the system colour scheme */
export function ThemeModeToggle(): React.JSX.Element {
  const dispatch = useAppDispatch();
  const { trackEvent } = useTrackEvent();
  const themeMode = useThemeMode();

  function handleChange(newThemeMode: ThemeModePreference): void {
    storeThemeMode(newThemeMode);
    dispatch(setThemeMode(newThemeMode));
    trackEvent({
      name: ExperimentalFeatureEvents.setThemeMode,
      props: { themeMode: newThemeMode },
    });
  }

  return (
    <ToggleGroup
      items={THEME_MODE_ITEMS}
      value={themeMode}
      onChange={handleChange}
    />
  );
}
